module.exports = __webpack_public_path__ + "static/media/lp-edu-5.ae52dbc0.svg";